// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"81":"b56a6f31","594":"e8fcc9f3"}[chunkId] + ".js";
};